import './HallOfFame.css'

const HallOfFame = () => {
    return (
      <div>
        {/* Banner Image */}
        <img
          className="HOF__Banner__Image"
          src="./images/HallOfFame/Banner_New.png"
          alt="banner"
        />

        {/* About text */}
        <div className="HOF__about__text">
          <p className="HOF__about__para">
            lorem ipsum dolor sit amet Lorem ipsum dolor sit amet consectetur
            adipisicing elit. Pariatur, ex quisquam. Repellat corrupti illum
            doloremque! Fugiat delectus ipsum ab ex nobis. Praesentium, autem
            iste vero ducimus esse nihil itaque natus. Lorem ipsum dolor sit
            amet consectetur adipisicing elit. Vitae atque fugiat, numquam sint
            corporis, fuga unde incidunt dolorum dignissimos voluptate ad
            assumenda cumque a commodi, id dolores. Hic, eum nobis. Lorem ipsum
            dolor sit amet consectetur, adipisicing elit. Cupiditate cumque
            quibusdam quidem sint sit illo expedita iste facere omnis delectus
            rem a, fugit quas incidunt impedit! Nemo dolor sed id!
          </p>
        </div>

        {/* buttons */}
        <div className="socialMediaWrap" id='home'>                
                <button className="iconBtn icon1">
                    <img
                    src="images/SocialLearning/present.svg"
                    alt="oracle-icon"
                    />
                    <span>Request for Training</span>
                </button>
                <button className="iconBtn icon2">
                    <img
                    src="images/SocialLearning/Yammer1.png"
                    alt="oracle-icon"
                    /><span>Connect with Community</span>
                </button>
                <button className="iconBtn icon3">
                    <img
                    src="images/SocialLearning/mail.svg"
                    alt="oracle-icon"
                    />
                    <span>Contact Us</span>
                </button>
            </div>
      </div>
    );
}

export default HallOfFame;